// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2a395a75","455":"a2fe17e5","977":"197de30f"}[chunkId] + ".chunk.js";
};